<template>
<!-- 听单分类抽屉 -->
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="inner">
                <header class="header paddingH16 paddingV16">
                    <div class="bold alignCenter font16r grey10">听歌分类</div>
                </header>
                <div class="body paddingV20">
                    <div class="content">
                        <ul style="margin-left:5%;margin-bottom:20px;">
                            <li @click="toLink(item.id)" class="listen-model" v-for="(item , index) in classifySumList.slice(0,8)" :key="index" >
                                    <img :src="item.img" alt="听单分类背景">
                                    <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="bgF5F5F5" style="height: 8px;"></div>
                    <div class="paddingV16 alignCenter grey10" @click="close()">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import drawerPart from '@comp/part/drawerPart';

export default {
    name: "drawerClassify",
    extends : drawerPart,
    props:['classifySumList'],
    data() {
        return {
            classifyData:[],
            linkId:'',

        }
    },
    methods:{
        toLink(id){
            this.linkId = id;
             this.$emit('childByValue', this.linkId);
             this.close();
        }
    },
    mounted(){
    }
}
</script>

<style lang="scss" scoped>
  //听单分类样式
    .content{
        ul{
            width: 90%;
            height: 84px;
            margin: 0;
            padding: 0;
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: space-between;
            // align-content: space-between;

            .listen-model{
                width: 23%;
                height: 38px;
                float: left;
                margin-right: 2%;
                margin-bottom: 2%;
                border-radius: 5px;
                list-style: none;
                // margin-top: 8px;
                position: relative;
                img{
                     border-radius: 5px;
                    width: 100%;
                    height: 100%;
                }
                span{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 56px;
                    height: 20px;
                    font-size: 14px;

                    font-weight: 400;
                    line-height: 14px;
                    color: #243544;

                    transform: translate(-50%,-50%);
                }

            }
        }
    }
</style>
